export const DATE_FORMATS = {
  ISO_SHORT: 'yyyy-MM-dd',
  DAY_MONTH_YEAR: 'dd.MM.yyyy',
  LOCAL_MONTH_YEAR: 'MMMM yyyy',
} as const
